/**
 * Utility functions for environment-specific checks
 */

export type EnvironmentString = "production" | "development" | "local";

/**
 * Checks if the current environment is local or development
 */
export const isLocalOrDev = (): boolean => {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT as EnvironmentString;
  return environment === "local" || environment === "development";
};

/**
 * Gets the current environment type
 */
export const getEnvironment = (): EnvironmentString => {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT as EnvironmentString;

  // Fallback to default values if environment variable is not set
  if (!environment) {
    return "local";
  }

  return environment;
};
